import { Container, TextField, Button } from '@mui/material';
import { Header } from '../shared/Header';
import ShareIcon from '@mui/icons-material/Share';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { useToast } from '../hooks/toastContext';
import useWindowDimensions from '../hooks/windowDimensions';
import { Footer } from '../shared/footer/Footer';
import './link.scss';

function SuccessPage() {
  const { width, isMobile } = useWindowDimensions();
  const { showToastMessage } = useToast();

  const handleCopyLink = () => {
    const url = localStorage.getItem('url');
    if (url) {
      navigator.clipboard.writeText(url);
      showToastMessage('Link copiado para a área de transferência!');
    }
  };

  const handleShareLink = () => {
    const url = localStorage.getItem('url');
    if (url) {
      if (navigator.share) {
        navigator
          .share({
            title: 'Meu Link',
            text: 'Confira meu link:',
            url: url,
          })
          .catch((error) => console.error('Error sharing:', error));
      } else {
        alert('Compartilhamento não suportado neste navegador.');
      }
    }
  };

  const calcMaxWidthImage = () => {
    const retWidth = width / 3.3;

    return retWidth > 430 ? 430 : retWidth;
  };

  return (
    <div id='link-page'>
      {isMobile ? (
        <section className="flex flex-col items-center pt-9">
          <Header></Header>
          <div className="px-6">
            <div className="mb-6 flex flex-col">
              <span className="font-medium mt-20" style={{ fontSize: '22px' }}>
                Copie seu link
              </span>
              <span className="text-lg mt-5">Seu link foi gerado com sucesso!</span>
            </div>

            <TextField style={{marginTop: '-20px'}} sx={{ width: '303px' }} value={localStorage.getItem('url')} InputProps={{ readOnly: true }} />

            <div className="mt-7 mb-32 flex gap-3">
              <Button
                className="z-50 cursor-pointer"
                sx={{ background: '#A53C75', borderRadius: '50px', textTransform: 'none', width: '145px' }}
                variant="contained"
                startIcon={<FileCopyIcon />}
                onClick={handleCopyLink}
              >
                Copiar link
              </Button>
              <Button
                className="z-50 cursor-pointer"
                sx={{ background: '#A53C75', borderRadius: '50px', textTransform: 'none', width: '145px' }}
                variant="contained"
                startIcon={<ShareIcon />}
                onClick={handleShareLink}
              >
                Compartilhar
              </Button>
            </div>
          </div>
          <Footer isMobile={true}></Footer>
        </section>
      ) : (
        <section className="flex flex-col">
          <div className="flex items-center gap-2">
            <div className="ml-auto left-panel mb-10 pt-20 mr-68" style={{ height: '60vh' }}>
              <Header></Header>
              <div className="mb-2.5 flex flex-col mt-28">
                <span className="font-medium" style={{ fontSize: '22px' }}>
                  Copie seu link
                </span>
                <span className="text-lg mt-2">Seu link foi gerado com sucesso!</span>
              </div>

              <TextField sx={{ width: '300px' }} value={localStorage.getItem('url')} InputProps={{ readOnly: true }} />

              <div className="relative mt-6 flex items-start gap-4">
                <Button
                  className="z-50 cursor-pointer"
                  sx={{ background: '#A53C75', borderRadius: '50px', textTransform: 'none', width: '138px' }}
                  variant="contained"
                  startIcon={<FileCopyIcon />}
                  onClick={handleCopyLink}
                >
                  Copiar link
                </Button>
                <Button
                  className="z-50 cursor-pointer"
                  sx={{
                    background: '#A53C75',
                    borderRadius: '50px',
                    textTransform: 'none',
                    width: '138px',
                  }}
                  variant="contained"
                  startIcon={<ShareIcon />}
                  onClick={handleShareLink}
                >
                  Compartilhar
                </Button>
              </div>
            </div>
            <div className="right-panel flex h-full self-end pr-12 relative">
              <img className="z-20" style={{ maxWidth: 440}} src="/images/illustration.png"></img>
              <img className='absolute w-15 z-50 top-36 left-11' src="/images/heart.svg"></img>
              <img className='absolute w-20 z-50 top-40 right-22' src="/images/scratch.svg"></img>
            </div>
              <img className="absolute top-0 right-0 z-10" style={{ maxWidth: calcMaxWidthImage() }} src="/images/circle-green.png"></img>
          </div>
          <div className="w-full">
            <Footer></Footer>
          </div>
        </section>
      )}
    </div>
  );
}

export default SuccessPage;
